import {
  GET_EMAIL_ID_VERIFY_SUCCESS,
  GET_EMAIL_ID_VERIFY_FAILURE,
  REGISTER_MEMBER_START,
  REGISTER_MEMBER_SUCCESS,
  REGISTER_MEMBER_FAILURE,
  GET_MEMBER_VERIFICATION_CODE_START,
  GET_MEMBER_VERIFICATION_CODE_SUCCESS,
  GET_MEMBER_VERIFICATION_CODE_FAILURE, RESET_REDIRECT_URL,
  MEMBER_LOGIN_REDIRECT_START, MEMBER_LOGIN_REDIRECT_SUCCESS, MEMBER_LOGIN_REDIRECT_FAILURE,
  MEMBER_AUTHENTICATION_START, MEMBER_AUTHENTICATION_SUCCESS, MEMBER_AUTHENTICATION_FAILURE,
  GET_MEMBER_DETAILS_FAILURE, GET_MEMBER_DETAILS_START, GET_MEMBER_DETAILS_SUCCESS,
  MEMBER_VALIDATION_FAILURE, MEMBER_VALIDATION_START, MEMBER_VALIDATION_SUCCESS,
  GET_AUTH_CODE_START, GET_AUTH_CODE_SUCCESS, GET_AUTH_CODE_FAILURE,
  EMAIL_VERIFICATION_START, EMAIL_VERIFICATION_SUCCESS, EMAIL_VERIFICATION_FAILURE,
  GET_EMAIL_VERIFICATION_CODE_START, GET_EMAIL_VERIFICATION_CODE_SUCCESS, GET_EMAIL_VERIFICATION_CODE_FAILURE
} from "./types";

import API from "./api";
import APIInternal from "./apiinternal";

export const validateMemberEmail = (emailId) => async dispatch => {
  // emailIDVerification
  const url = `/api/emailIDVerification`;
  try {
      const payload = {
        "args": emailId
      };
      const response = await APIInternal.post(url, payload);
      if(response.data){
        // console.log("success during verification of email");
        dispatch({type: GET_EMAIL_ID_VERIFY_SUCCESS, payload: response.data});
      } else {
        // console.log("failure during verification of email");
        dispatch({type: GET_EMAIL_ID_VERIFY_FAILURE, payload: 'No Response for Email Verification'});    
      }
  } catch (e) {
      // console.log("error in verification of email");
      dispatch({type: GET_EMAIL_ID_VERIFY_FAILURE, errorMessage: 'Email verification failure'});
  }
}

export const registerMember = (params, callback) => async dispatch => {
  dispatch({ type: REGISTER_MEMBER_START });
  const url = `/myelth-idm-services/v1/member-registration`;
  // console.log("In actions", JSON.stringify(params));
  // https://dev-icare.myelth.com/myelth-idm-services/v1/member-registration
  try {
      const response = await APIInternal.post(url, params);
      if(response.data){
        // console.log("success registering Member", JSON.stringify(response.data));
        dispatch({type: REGISTER_MEMBER_SUCCESS, payload: response.data, userParams: params});
        if (callback) {
          callback();
        }
      } else {
        dispatch({type: REGISTER_MEMBER_FAILURE, payload: 'No Response from registering Member'});    
      }
  } catch (e) {
      dispatch({type: REGISTER_MEMBER_FAILURE, errorMessage: e && e.response && e.response.data});
  }
}

export const getMemberVerificationCode = (params, callback) => async dispatch => {
  dispatch({ type: GET_MEMBER_VERIFICATION_CODE_START });
  const url = `/myelth-idm-services/v1/member-activation-code`;
  // console.log("getMemberVerificationCode", JSON.stringify(params));
  try {
      const response = await APIInternal.post(url, params);
      if(response.data){
        // console.log("success getting Verification code'", JSON.stringify(response.data));
        dispatch({type: GET_MEMBER_VERIFICATION_CODE_SUCCESS, payload: response.data});
        if (callback) {
          callback();
        }
      } else {
        dispatch({type: GET_MEMBER_VERIFICATION_CODE_FAILURE, payload: 'No Response from get Verification code'});    
      }
  } catch (e) {
      dispatch({type: GET_MEMBER_VERIFICATION_CODE_FAILURE, errorMessage: 'get Verification code failure'});
  }
}

export const memberActivation = (params, callback) => async dispatch => {
  dispatch({ type: REGISTER_MEMBER_START });
  const url = `/myelth-idm-services/v1/member-activation`;
  // console.log("In actions", JSON.stringify(params));
  try {
      const response = await APIInternal.post(url, params);
      if(response.data){
        dispatch({type: REGISTER_MEMBER_SUCCESS, payload: response.data});
        if (callback) {
          callback();
        }
      } else {
        dispatch({type: REGISTER_MEMBER_FAILURE, payload: 'No Response from registering Member'});    
      }
  } catch (e) {
    // console.log("success getting Verification code'", JSON.stringify(e && e.response && e.response.data));
      dispatch({type: REGISTER_MEMBER_FAILURE, errorMessage: e && e.response && e.response.data});
  }
}

export const resetErrorMsg = {
  type: "RESET_ERROR_MESSAGE"
}

export const resetURL = {
  type: "RESET_REDIRECT_URL"
}

// https://dev-icare.myelth.com/oauth2/v1/member-login
export const memberLoginRedirect = (params, callback) => async dispatch => {
  dispatch({ type: MEMBER_LOGIN_REDIRECT_START });
  // const url = `/myelth-idm-services/v1/member-login`;
  const url = `/oauth2/v1/member-login`;
  try {
      const response = await API.post(url, params);
      if(response.data){
        // console.log("Member Redirect Login:", JSON.stringify(response.data));
        dispatch({type: MEMBER_LOGIN_REDIRECT_SUCCESS, payload: response.data});
        if (callback) {
          callback();
        }
      } else {
        dispatch({type: MEMBER_LOGIN_REDIRECT_FAILURE, payload: 'No Response from registering Member'});    
      }
  } catch (e) {
      dispatch({type: MEMBER_LOGIN_REDIRECT_FAILURE, errorMessage: 'Register Member failure'});
  }
}

export const memberAuthentication = (params, callback) => async dispatch => {
  dispatch({ type: MEMBER_AUTHENTICATION_START });
  // const url = `/myelth-idm-services/v1/member-authentication`;
  const url = "/oauth2/v1/member-authentication";
  try {
      const response = await API.post(url, params);
      if(response.data){
        console.log("Member Authentication:", JSON.stringify(response.data));
        dispatch({type: MEMBER_AUTHENTICATION_SUCCESS, payload: response.data});
        const url = response.data.response.url;
        if (callback) {
          callback(url);
        }
      } else {
        dispatch({type: MEMBER_AUTHENTICATION_FAILURE, payload: 'No Response from registering Member'});    
      }
  } catch (e) {
    // console.log(e.response.data.response.error)
      dispatch({type: MEMBER_AUTHENTICATION_FAILURE, loginErrorMsg: e?.response?.data?.response?.error });
  }
}


export const getMemberDetails = (params, callback) => async dispatch => {
  dispatch({ type: GET_MEMBER_DETAILS_START });
  const url = `/myelth-idm-services/v1/id-token-decrypt?idToken=${params}&clientSecret=MDRmMDc0YzgtNzlkMi00YzNiLWJjZjEtZmFhMzFkYjE0OTFk`;
  try {
      const response = await APIInternal.post(url);
      // console.log(JSON.stringify(response));
      if(response.data){
        // console.log("Member Details:", JSON.stringify(response.data));
        dispatch({type: GET_MEMBER_DETAILS_SUCCESS, payload: response.data});
        if (callback) {
          callback();
        }
      } else {
        dispatch({type: GET_MEMBER_DETAILS_FAILURE, payload: 'No Response from Member Details'});    
      }
  } catch (e) {
      dispatch({type: GET_MEMBER_DETAILS_FAILURE, errorMessage: 'No Member Details Available'});
  }
}

export const validateMember = (params, callback) => async dispatch => {
  dispatch({ type: MEMBER_VALIDATION_START });
  const url = `/myelth-idm-services/v1/member-validation`;
  try {
      const response = await APIInternal.post(url, params);
      if(response.data){
        dispatch({type: MEMBER_VALIDATION_SUCCESS, payload: response.data});
        if (callback) {
          callback();
        }
      } else {
        dispatch({type: MEMBER_VALIDATION_FAILURE, payload: 'No Response from Member Details'});    
      }
  } catch (e) {
    console.log(JSON.stringify(e))
      dispatch({type: MEMBER_VALIDATION_FAILURE, errorMessage: e && e.response && e.response.data && e.response.data.message});
  }
}


export const getAuthCode = (params, callback) => async dispatch => {
  dispatch({ type: GET_AUTH_CODE_START });
  const url = `/oauth2/v1/genauthcode`;
  try {
      const response = await API.post(url, params);
      if(response.data){
        dispatch({type: GET_AUTH_CODE_SUCCESS, payload: response.data});
        if (callback) {
          callback();
        }
      } else {
        dispatch({type: GET_AUTH_CODE_FAILURE, payload: 'No Response from Member Details'});    
      }
  } catch (e) {
      dispatch({type: GET_AUTH_CODE_FAILURE, errorMessage: e && e.response && e.response.data && e.response.data.message});
  }
}

export const getEmailVerificationCode = (params, callback) => async dispatch => {
  dispatch({ type: GET_EMAIL_VERIFICATION_CODE_START });
  const url = `/myelth-idm-services/v1/member-email-code`;
  try {
      const response = await APIInternal.post(url, params);
      if(response.data){
        dispatch({type: GET_EMAIL_VERIFICATION_CODE_SUCCESS, payload: response.data});
        if (callback) {
          callback();
        }
      } else {
        dispatch({type: GET_EMAIL_VERIFICATION_CODE_FAILURE, payload: 'No Response from email verification code'});    
      }
  } catch (e) {
      dispatch({type: GET_EMAIL_VERIFICATION_CODE_FAILURE, errorMessage: e && e.response && e.response.data && e.response.data.message});
  }
}

export const verifyEmail = (params, callback) => async dispatch => {
  dispatch({ type: EMAIL_VERIFICATION_START });
  const url = `/myelth-idm-services/v1/member-email-verify`;
  try {
      const response = await APIInternal.post(url, params);
      if(response.data){
        dispatch({type: EMAIL_VERIFICATION_SUCCESS, payload: response.data});
        if (callback) {
          callback();
        }
      } else {
        dispatch({type: EMAIL_VERIFICATION_FAILURE, payload: 'No Response from email verification'});    
      }
  } catch (e) {
      dispatch({type: EMAIL_VERIFICATION_FAILURE, errorMessage: e && e.response && e.response.data && e.response.data.message});
  }
}